import React, {Suspense, useEffect, useState} from 'react';
import {Route, useLocation, useNavigate} from 'react-router-dom';
import IsAuthorized from './roleCheck';
import MainLayout from '../Layout/mainLayout';
import AdminLayout from '../Layout/adminLayout';
import {useJWTAuthActions} from '../../../Api/JWTAuthProvider';
import ChunkErrorBoundary from '../ChunkErrorBoundary';
import PageLoader from '../PageLoader';

const ProtectedRoute = ({
  element,
  allowedLayout,
  isProtectedRoute,
  allowedRoles,
}) => {
  const navigate = useNavigate();
  const {pathname} = useLocation();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const {logout} = useJWTAuthActions();
  const checkAuthToken = () => {
    const authToken = localStorage.getItem('token');
    if ((!authToken || authToken === 'undefined') && isProtectedRoute) {
      logout();
      setIsLoggedIn(false);

      return navigate('/login');
    }
    setIsLoggedIn(true);
  };
  const renderPage = (page) => (
    <ChunkErrorBoundary resetKey={pathname}>
      <Suspense fallback={<PageLoader />}>{page}</Suspense>
    </ChunkErrorBoundary>
  );
  const checkLayoutType = (element) => {
    switch (allowedLayout) {
      case 'main':
        return <MainLayout>{renderPage(element)}</MainLayout>;
      case 'admin':
        return <AdminLayout>{renderPage(element)}</AdminLayout>;
      default:
        return renderPage(element);
    }
  };
  useEffect(() => {
    checkAuthToken();
  }, [isLoggedIn]);

  return isProtectedRoute ? (
    <IsAuthorized
      isLoggedIn={isLoggedIn}
      allowedRoles={allowedRoles}
      element={checkLayoutType(element)}
    />
  ) : (
    <>{checkLayoutType(element)}</>
  );
};
export default ProtectedRoute;
